import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, setCurrentUser } from '../../Store/user/userSlice';
import { getOrders } from '../../Store/orders/ordersSlice';
import styles from '../../styles/AdminPanel.module.scss';

const AdminLogin = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);
  const [values, setValues] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setValues((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch(setCurrentUser(null));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!values.email || !values.password) {
      setError('Введіть email і пароль');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const result = await dispatch(loginUser(values)).unwrap();
      const role = String(result.role || '').toUpperCase();
      if (role !== 'ADMIN') {
        setError('Цей акаунт не є адміністратором');
        localStorage.removeItem('token');
        dispatch(setCurrentUser(null));
      } else {
        dispatch(getOrders());
      }
    } catch (err) {
      setError(typeof err === 'string' ? err : 'Невірний email або пароль');
    } finally {
      setLoading(false);
    }
  };

  const isUser = currentUser && String(currentUser.role).toUpperCase() !== 'ADMIN';

  return (
    <div className={styles.adminLoginWrap}>
      <h1 className={styles.adminLoginTitle}>Вхід в адмін-панель</h1>

      {isUser && (
        <div className={styles.adminLoginHint}>
          Ви увійшли як <strong>{currentUser.email}</strong> (роль: користувач).
          Для адмінки потрібен акаунт адміністратора.
          <button type="button" className={styles.adminLoginLogout} onClick={handleLogout}>
            Вийти
          </button>
        </div>
      )}

      <form className={styles.adminLoginForm} onSubmit={handleSubmit}>
        <label>
          Email
          <input
            type="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            placeholder="Введіть email"
            autoComplete="username"
            required
          />
        </label>
        <label>
          Пароль
          <input
            type="password"
            name="password"
            value={values.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />
        </label>
        {error && <p className={styles.error}>{error}</p>}
        <button type="submit" className={styles.adminLoginSubmit} disabled={loading}>
          {loading ? 'Вхід…' : 'Увійти'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
